import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBox } from './../../../../shared/message-box';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

class ErreurInscription {

  any: boolean; //Une erreur peu importe laquelle.

  aucunNom: boolean;
  aucunPrenom: boolean;
  aucunCourriel: boolean;
  aucunCollege: boolean;
  aucunProfession: boolean;


  constructor() {
    this.reset();
  }


  public reset() {
    this.any              = false;
    this.aucunNom         = false;
    this.aucunPrenom      = false;
    this.aucunCourriel    = false;
    this.aucunCollege     = false;
    this.aucunProfession  = false;
    }
}


@Component({
  selector: 'app-inscription',
  templateUrl: './inscription.component.html',
  styleUrls: ['./inscription.component.scss']
})

export class InscriptionComponent implements OnInit, OnDestroy {


  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  public currentLang: string;
  public erreurs: ErreurInscription;

  public nom: string;
  public prenom: string;
  public courriel: string;
  public college: string;
  public profession: string;
  public progFGP: boolean;
  public progFGF: boolean;
  public progFGB: boolean;
  public progFGI: boolean;
  public progPP2: boolean;
  public progAutres: string;
  

  constructor(private translateService: TranslateService, private dialog: MatDialog, private http: HttpClient ) {
    this.currentLang = this.translateService.currentLang;
    this.ngUnsubscribe = new Subject<void>();
    
    this.erreurs = new ErreurInscription();
    
    this.nom = '';
    this.prenom = '';
    this.courriel = '';
    this.college = '';
    this.profession = '';
    this.progFGP = false;
    this.progFGF = false;
    this.progFGB = false;
    this.progFGI = false;
    this.progPP2 = false;
    this.progAutres = '';
    
    this.http
  }

  async ngOnInit() {

    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }​​​​​​​​

  //Valide le formulaire et prépare l'envoie du message.
  public btnEnvoyerClick() {


    if( this.validerFormulaire() ) {
         
        //Envoyer la demande à PP2/Plurilogic.
/*        
        $.post("https://martina2021.plurilogic.com/pluriportail/pfr/PlurisiteEx.srf?GetDetail=O", { PostInscription: true }, function (data) {

          if (data.Retour == 0) {
            alert("Ok");
          }
      
      }, "json");
*/
          this.http.post<any>('https://martina2021.plurilogic.com/pluriportail/pfr/PlurisiteEx.srf?GetDetail=O', { PostInscription: true }).subscribe(data => {
            
            if (data.Retour == 0) {
              alert("Ok");
            }
      });


    }
    else {
      MessageBox.show(this.dialog, this.translateService.instant('formInscr.erreurChampsManquants'), this.translateService.instant('formInscr.avertissement'), "", 0, false, 1);
    }
  }

  //Retourne vrai si le formulaire est valide sinon les champs appropriés sont marqués d'une erreur.
  private validerFormulaire( estBrouillon: boolean = false ): boolean {

    this.erreurs.reset();

    this.erreurs.aucunNom = this.nom.length === 0;
    this.erreurs.aucunPrenom = this.prenom.length === 0;
    this.erreurs.aucunCourriel = this.courriel.length === 0;
    this.erreurs.aucunCollege = this.college.length === 0;
    this.erreurs.aucunProfession = this.profession.length === 0;
  
    this.erreurs.any = this.erreurs.aucunNom || this.erreurs.aucunPrenom || this.erreurs.aucunCourriel || this.erreurs.aucunCollege || this.erreurs.aucunProfession;

    return !this.erreurs.any;
  }

}
